/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AccountDetailResponse } from '../model';
// @ts-ignore
import { AccountTransactionResponse } from '../model';
// @ts-ignore
import { CreateAccountTransactionRequest } from '../model';
// @ts-ignore
import { UpdateAccountTransactionRequest } from '../model';
/**
 * AdminAccountControllerApi - axios parameter creator
 * @export
 */
export const AdminAccountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} accountId 
         * @param {CreateAccountTransactionRequest} createAccountTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction: async (accountId: string, createAccountTransactionRequest: CreateAccountTransactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createTransaction', 'accountId', accountId)
            // verify required parameter 'createAccountTransactionRequest' is not null or undefined
            assertParamExists('createTransaction', 'createAccountTransactionRequest', createAccountTransactionRequest)
            const localVarPath = `/admin/accounts/{accountId}/transactions`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransaction: async (accountId: string, transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteTransaction', 'accountId', accountId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('deleteTransaction', 'transactionId', transactionId)
            const localVarPath = `/admin/accounts/{accountId}/transactions/{transactionId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByHubId: async (hubId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hubId' is not null or undefined
            assertParamExists('getByHubId', 'hubId', hubId)
            const localVarPath = `/admin/hubs/{hubId}/account`
                .replace(`{${"hubId"}}`, encodeURIComponent(String(hubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPartnerId: async (partnerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getByPartnerId', 'partnerId', partnerId)
            const localVarPath = `/admin/partners/{partnerId}/account`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions: async (accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listTransactions', 'accountId', accountId)
            const localVarPath = `/admin/accounts/{accountId}/transactions`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} transactionId 
         * @param {UpdateAccountTransactionRequest} updateAccountTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction: async (accountId: string, transactionId: string, updateAccountTransactionRequest: UpdateAccountTransactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateTransaction', 'accountId', accountId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('updateTransaction', 'transactionId', transactionId)
            // verify required parameter 'updateAccountTransactionRequest' is not null or undefined
            assertParamExists('updateTransaction', 'updateAccountTransactionRequest', updateAccountTransactionRequest)
            const localVarPath = `/admin/accounts/{accountId}/transactions/{transactionId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAccountControllerApi - functional programming interface
 * @export
 */
export const AdminAccountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAccountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} accountId 
         * @param {CreateAccountTransactionRequest} createAccountTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransaction(accountId: string, createAccountTransactionRequest: CreateAccountTransactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransaction(accountId, createAccountTransactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTransaction(accountId: string, transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTransaction(accountId, transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByHubId(hubId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByHubId(hubId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByPartnerId(partnerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByPartnerId(partnerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransactions(accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountTransactionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransactions(accountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} transactionId 
         * @param {UpdateAccountTransactionRequest} updateAccountTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransaction(accountId: string, transactionId: string, updateAccountTransactionRequest: UpdateAccountTransactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransaction(accountId, transactionId, updateAccountTransactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminAccountControllerApi - factory interface
 * @export
 */
export const AdminAccountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAccountControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} accountId 
         * @param {CreateAccountTransactionRequest} createAccountTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction(accountId: string, createAccountTransactionRequest: CreateAccountTransactionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createTransaction(accountId, createAccountTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransaction(accountId: string, transactionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTransaction(accountId, transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByHubId(hubId: string, options?: any): AxiosPromise<AccountDetailResponse> {
            return localVarFp.getByHubId(hubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByPartnerId(partnerId: string, options?: any): AxiosPromise<AccountDetailResponse> {
            return localVarFp.getByPartnerId(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions(accountId: string, options?: any): AxiosPromise<Array<AccountTransactionResponse>> {
            return localVarFp.listTransactions(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} transactionId 
         * @param {UpdateAccountTransactionRequest} updateAccountTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransaction(accountId: string, transactionId: string, updateAccountTransactionRequest: UpdateAccountTransactionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateTransaction(accountId, transactionId, updateAccountTransactionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAccountControllerApi - object-oriented interface
 * @export
 * @class AdminAccountControllerApi
 * @extends {BaseAPI}
 */
export class AdminAccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} accountId 
     * @param {CreateAccountTransactionRequest} createAccountTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public createTransaction(accountId: string, createAccountTransactionRequest: CreateAccountTransactionRequest, options?: AxiosRequestConfig) {
        return AdminAccountControllerApiFp(this.configuration).createTransaction(accountId, createAccountTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} accountId 
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public deleteTransaction(accountId: string, transactionId: string, options?: AxiosRequestConfig) {
        return AdminAccountControllerApiFp(this.configuration).deleteTransaction(accountId, transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} hubId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public getByHubId(hubId: string, options?: AxiosRequestConfig) {
        return AdminAccountControllerApiFp(this.configuration).getByHubId(hubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public getByPartnerId(partnerId: string, options?: AxiosRequestConfig) {
        return AdminAccountControllerApiFp(this.configuration).getByPartnerId(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public listTransactions(accountId: string, options?: AxiosRequestConfig) {
        return AdminAccountControllerApiFp(this.configuration).listTransactions(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} accountId 
     * @param {string} transactionId 
     * @param {UpdateAccountTransactionRequest} updateAccountTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public updateTransaction(accountId: string, transactionId: string, updateAccountTransactionRequest: UpdateAccountTransactionRequest, options?: AxiosRequestConfig) {
        return AdminAccountControllerApiFp(this.configuration).updateTransaction(accountId, transactionId, updateAccountTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

